export { Suggestions } from './Suggestions'


// WEBPACK FOOTER //
// ./src/components/Autocomplete/components/Suggestions/index.js